<template>
    <el-popover
        popper-class="__show-more-component-class__"
        placement="bottom-start"
        trigger="click"
        v-on="$listeners"
        v-bind="$attrs"
        @show="isShowMoreOperate = true"
        @hide="isShowMoreOperate = false">
        <div slot="reference" class="more-operate fx-center mr-10 fs-14 color-333" :class="{ 'is-active': isShowMoreOperate }">
            <span class="mr-4">{{ title }}</span>
            <i class="el-icon-arrow-down fw-600"/>
        </div>
        <slot/>
    </el-popover>
</template>

<script lang='ts'>
import { createComponent, ref } from '@vue/composition-api'

export default createComponent({
    props: {
        title: {
            type: String,
            default: '更多操作'
        }
    },

    setup(props, ctx) {
        const isShowMoreOperate = ref(false)

        // 通过JS 关闭Popover
        function hide() {
            (document.getElementById('app') as any).click()
        }

        return {
            isShowMoreOperate,
            hide
        }
    }
})
</script>

<style lang="scss">
.__show-more-component-class__ {
    min-width: auto !important;
    padding: 6px 0 !important;
}
</style>

<style lang="scss" scoped>
.more-operate {
        width: 100px;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 4px;
        outline: none;
        cursor: pointer;

        .el-icon-arrow-down {
            transition: all .25s;
        }

        &.is-active {
            .el-icon-arrow-down {
                transform: rotate(180deg);
            }
        }
    }
</style>
